import { MinimalLayout } from '../components/templates/MinimalLayout.js';
import { Typography } from '../components/atoms/Typography.js';

export function PrivacyPolicyPage() {
  return (
    <MinimalLayout>
      <div className="space-y-6">
        <Typography variant="h2">プライバシーポリシー</Typography>
        <Typography variant="caption">最終更新日: 2025年1月1日</Typography>

        <section className="space-y-2">
          <Typography variant="h4">1. はじめに</Typography>
          <Typography variant="body-sm">
            PulseAgent（以下「本サービス」）は、ユーザーのプライバシーを尊重し、
            個人情報の保護に努めます。本プライバシーポリシーは、本サービスにおける
            個人情報の取り扱いについて説明するものです。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">2. 収集する情報</Typography>
          <Typography variant="body-sm">
            本サービスでは、以下の情報を収集する場合があります。
          </Typography>
          <ul className="list-disc pl-6 text-sm text-neutral-600 space-y-1">
            <li>インタビューにおける音声データおよびテキストデータ</li>
            <li>サーベイへの回答内容</li>
            <li>サービス利用に関するログ情報</li>
          </ul>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">3. 情報の利用目的</Typography>
          <Typography variant="body-sm">収集した情報は、以下の目的で利用します。</Typography>
          <ul className="list-disc pl-6 text-sm text-neutral-600 space-y-1">
            <li>サーベイ結果の分析およびレポートの生成</li>
            <li>サービスの品質向上および機能改善</li>
            <li>ユーザーサポートの提供</li>
          </ul>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">4. 音声データの取り扱い</Typography>
          <Typography variant="body-sm">
            本サービスでは、音声認識処理をすべてユーザーのデバイス上で行います。
            音声データが外部サーバーに送信されることはありません。
            テキスト化されたデータのみがサーバーに保存されます。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">5. データの保管と削除</Typography>
          <Typography variant="body-sm">
            収集したデータは、利用目的の達成に必要な期間のみ保管します。
            ユーザーはいつでもデータの削除を要求することができます。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">6. 第三者への提供</Typography>
          <Typography variant="body-sm">
            ユーザーの同意なく、個人情報を第三者に提供することはありません。
            ただし、法令に基づく場合はこの限りではありません。
          </Typography>
        </section>

        <section className="space-y-2">
          <Typography variant="h4">7. お問い合わせ</Typography>
          <Typography variant="body-sm">
            本ポリシーに関するお問い合わせは、サービス内のお問い合わせ機能より ご連絡ください。
          </Typography>
        </section>
      </div>
    </MinimalLayout>
  );
}
